
































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Transcription from '../../store/modules/transcription';
import store from '@/store/store';
const trscModule = getModule(Transcription, store);

@Component
export default class ShareTranscriptionDialog extends Vue {
  @Prop(Boolean)
  value!: boolean;
  @Prop(Number)
  count!: number;

  get show() {
    return this.value;
  }
  set show(value) {
    this.$emit('input', value);
  }

  get twShareURL() {
    const label = trscModule.entry.label;
    const base = 'https://twitter.com/intent/tweet';
    const text = `I transcribed ${this.count} characters of ${label}! @CloudHonkoku https://wakancambridge.com/project-2020/`;
    const hashtags = 'みんなで翻刻';
    return `${base}?text=${encodeURI(text)}&hashtags=${hashtags}&url=${
      this.url
    }`;
  }

  get fbShareURL() {
    const label = trscModule.entry.label;
    const base = 'https://www.facebook.com/sharer/sharer.php?';
    const text = `I have transcribed ${this.count} characters of ${label} #みんなで翻刻`;
    const url = 'https://honkoku.org';
    return `${base}?u=${this.url}&text=${encodeURI(text)}`;
  }

  get url(): string {
    const { entryId, page } = this.$route.params;
    return `https://honkoku.org/app/%23/transcription/${entryId}/${page}/`;
  }
}
